import { MenuItem } from "@components/types";

// export const menuItems: MenuItem[] = [
//   {
//     category: ["breakfast", "lunch", "dinner"],
//     title: "Hummus Platter",
//     description: "House made plain and roasted red pepper hummus...",
//     price: "$12",
//   },
//   {
//     category: ["lunch", "dinner"],
//     title: "Sandwitch Platter",
//     description: "House made plain and roasted red pepper hummus...",
//     price: "$12",
//   },
//   {
//     category: ["dinner"],
//     title: "Hummus Platter",
//     description: "House made plain and roasted red pepper hummus...",
//     price: "$12",
//   },
// ];

export const categoryMapping = {
  Starters: "starters",
  Brunch: "brunch",
  Lunch: "Lunch",
  Dinner: "Dinner",
  Desserts: "desserts",
};
